import { assertUnreachable } from '@sgme/fp';
import { CpOrderForm } from 'components/secondaryMarket/cpOrder/cpOrderForm';
import { CpOrderFormContent } from 'components/secondaryMarket/cpOrder/cpOrderFormContent';
import { LimitOrderForm } from 'components/secondaryMarket/limitOrder/LimitOrderForm';
import { LiveForm } from 'components/secondaryMarket/live/liveForm';
import { connectLimitOrderForm } from 'components/Workspaces/SecondaryMarketPostEvent/Tabs/limitOrder/limitOrderForm.connect';
import { LimitOrderFormContent } from 'components/Workspaces/SecondaryMarketPostEvent/Tabs/limitOrder/limitOrderFormContent';
import { ConnectedAmendLimitOrderTradeSidePanel } from 'components/Workspaces/SecondaryMarketPostEvent/Tabs/limitOrder/sidePanel.connect';
import { LiveFormContent } from 'components/Workspaces/SecondaryMarketPostEvent/Tabs/live/liveFormContent';
import { ConnectedAmendLiveTradeSidePanel } from 'components/Workspaces/SecondaryMarketPostEvent/Tabs/live/sidePanel.connect';
import { FC } from 'react';
import type { SecondaryMarketPostEventTabType } from 'state/workspaces/model';

import { connectCpOrderForm } from './cpOrder/cpOrderForm.connect';
import { connectCpOrderFormContent } from './cpOrder/cpOrderFormContent.connect';
import { connectLiveForm } from './live/liveForm.connect';
import { ConnectedAmendCpOrderSidePanel } from './sidePanel';

const ConnectedCpOrderForm = connectCpOrderForm(CpOrderForm);
const ConnectedCpOrderFormContent = connectCpOrderFormContent(CpOrderFormContent);

const ConnectedLiveForm = connectLiveForm(LiveForm);
const ConnectedLimitOrderForm = connectLimitOrderForm(LimitOrderForm);

type SecondaryMarketPostEventTabProps = { tabId: string; tabType: SecondaryMarketPostEventTabType };
export const SecondaryMarketPostEventTab: FC<SecondaryMarketPostEventTabProps> = ({ tabId, tabType }) => {
  switch (tabType) {
    case 'closePriceOrder':
      return (
        <ConnectedCpOrderForm
          tabId={tabId}
          sidePanel={<ConnectedAmendCpOrderSidePanel tabId={tabId} tabType={tabType} />}
        >
          <ConnectedCpOrderFormContent tabId={tabId} workspaceType="secondaryMarketPostEvents" isModification={true} />
        </ConnectedCpOrderForm>
      );
    case 'live':
      return (
        <ConnectedLiveForm
          tabId={tabId}
          sidePanel={
            <ConnectedAmendLiveTradeSidePanel
              tabId={tabId}
              tabType={tabType}
              title="secondaryMarket.sidePanel.label.amend.live.summary"
              applyLabelKey="secondaryMarket.sidePanel.label.apply"
              readyLabelKey="secondaryMarket.sidePanel.live.amendReady"
              notReadyLabelKey="secondaryMarket.sidePanel.live.amendNotReady"
            />
          }
          workspaceType="secondaryMarketPostEvents"
        >
          <LiveFormContent tabId={tabId} />
        </ConnectedLiveForm>
      );
    case 'limitOrder':
      return (
        <ConnectedLimitOrderForm
          tabId={tabId}
          workspaceType="secondaryMarketPostEvents"
          sidePanel={
            <ConnectedAmendLimitOrderTradeSidePanel
              tabId={tabId}
              tabType={tabType}
              title="secondaryMarket.sidePanel.label.amend.limitOrder.summary"
              applyLabelKey="secondaryMarket.sidePanel.label.apply"
              readyLabelKey="secondaryMarket.sidePanel.limitOrder.amendReady"
              notReadyLabelKey="secondaryMarket.sidePanel.limitOrder.amendNotReady"
            />
          }
        >
          <LimitOrderFormContent tabId={tabId} />
        </ConnectedLimitOrderForm>
      );
    default:
      return assertUnreachable(tabType, 'Unhandled tab type');
  }
};
